class BackToTopButtonInitService {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('alpine:init', () => {
            Alpine.data('backToTopButton', () => ({
                backToTopButtonAttributes: {
                    ['@click']() {
                        this.handleClick();
                    },
                },
                handleClick() {
                    const targetTop: HTMLElement = document.querySelector('#target-top');
                    if (targetTop) {
                        targetTop.focus({
                            preventScroll: true,
                        });
                    }
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                },
            }));
        });
    }
}

export default new BackToTopButtonInitService();
